import { render, staticRenderFns } from "./inspectForm.vue?vue&type=template&id=5c04933b&"
import script from "./inspectForm.vue?vue&type=script&lang=js&"
export * from "./inspectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports